import { useRecoilState } from "recoil";
import { userListState } from "../atom/atom";
import { useEffect, useState } from "react";
import { fetchAndSetData, fetchUserList } from "../api/fetch.api";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../firebase/firebaseConfig";
import { update유저정보 } from "../api/update.api";
import { doc, updateDoc } from "firebase/firestore";
import { Collections } from "../types/type";

function UserPage() {
  const [userList, setUserList] = useRecoilState(userListState);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingUserId, setEditingUserId] = useState<string | null>(null);
  const [newUserName, setNewUserName] = useState("");
  const [editingCredit, setEditingCredit] = useState<string | null>(null);
  const [newCreditAmount, setNewCreditAmount] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentDeletingId, setCurrentDeletingId] = useState<string | null>(
    null
  );

  useEffect(() => {
    fetchAndSetData(fetchUserList, setUserList);
  }, []);

  console.log("userList : ", userList);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const filteredUsers = userList.filter((user) => {
    if (!user || !user.userId || !user.email) {
      console.log("failedUser : ", user?.userId, user?.email);
      return false;
    }

    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      user.userId.toLowerCase().includes(lowerCaseSearchTerm) ||
      user.email.toLowerCase().includes(lowerCaseSearchTerm)
    );
  });

  const handleChangeUserInfo = async ({
    userId,
    newUserName,
  }: {
    userId: string;
    newUserName: string;
  }) => {
    try {
      await update유저정보({ userId, newUserName });
      // Update local state to reflect changes
      setUserList((prevList) =>
        prevList.map((user) =>
          user.userId === userId ? { ...user, userName: newUserName } : user
        )
      );
      window.alert("변경 완료");
    } catch (error) {
      console.error("handleChangeUserInfo error : ", error);
    }
  };

  const handleUpdateCredit = async (userId: string, newAmount: string) => {
    try {
      const userRef = doc(db, Collections.USER, userId);
      await updateDoc(userRef, {
        "credit.balance": Number(newAmount),
      });
      // Update local state to reflect changes
      setUserList((prevList) =>
        prevList.map((user) =>
          user.userId === userId
            ? {
                ...user,
                credit: { ...user.credit, balance: Number(newAmount) },
              }
            : user
        )
      );
      alert("크레딧이 업데이트되었습니다.");
      setEditingCredit(null);
      setNewCreditAmount("");
    } catch (error) {
      console.error("크레딧 업데이트 중 오류 발생:", error);
      alert("크레딧 업데이트에 실패했습니다.");
    }
  };

  const handleDeleteUser = async (userId: string) => {
    if (
      !window.confirm(
        "정말 이 유저를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다."
      )
    ) {
      return;
    }

    try {
      setIsDeleting(true);
      setCurrentDeletingId(userId);

      const deleteUserFunction = httpsCallable(functions, "deleteUser");
      const result = await deleteUserFunction({ userId });

      const { success, message } = result.data as {
        success: boolean;
        message: string;
      };

      if (success) {
        setUserList((prevList) =>
          prevList.filter((user) => user.userId !== userId)
        );
        window.alert(message);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      window.alert("유저 삭제 중 오류가 발생했습니다.");
    } finally {
      setIsDeleting(false);
      setCurrentDeletingId(null);
    }
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start", gap: 48 }}>
        <h1>User Data</h1>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <h3>유저검색</h3>
          <input
            type="text"
            placeholder="유저 ID 또는 이메일 검색"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </div>
      {filteredUsers.map((user, index) => (
        <div
          key={user.userId + index + user.email}
          style={{
            border: "1px solid #454040",
            margin: "10px",
            padding: "10px",
          }}
        >
          <p>UserId: {user.userId}</p>
          <p>Email: {user.email}</p>
          <p>UserName: {user.userName}</p>
          <p>FCM Token: {user.fcmToken}</p>

          {/* Credit Information and Edit */}
          <div style={{ marginBottom: "10px" }}>
            <p>크레딧 잔액: {user.credit?.balance || 0}</p>
            <p>추천 코드: {user.credit?.referralCode || "N/A"}</p>
            {editingCredit === user.userId ? (
              <div style={{ marginTop: "5px" }}>
                <input
                  type="number"
                  value={newCreditAmount}
                  onChange={(e) => setNewCreditAmount(e.target.value)}
                  placeholder="새로운 크레딧 금액"
                />
                <button
                  onClick={() =>
                    handleUpdateCredit(user.userId, newCreditAmount)
                  }
                >
                  확인
                </button>
                <button
                  onClick={() => {
                    setEditingCredit(null);
                    setNewCreditAmount("");
                  }}
                >
                  취소
                </button>
              </div>
            ) : (
              <button onClick={() => setEditingCredit(user.userId)}>
                크레딧 수정
              </button>
            )}
          </div>

          {/* Genre Tags */}
          <div style={{ marginBottom: "10px" }}>
            <p>장르 태그:</p>
            {user.tag?.genreList?.map((genre, idx) => (
              <span
                key={idx}
                style={{
                  background: "#e0e0e0",
                  padding: "2px 8px",
                  margin: "0 4px",
                  borderRadius: "4px",
                }}
              >
                {genre}
              </span>
            ))}
          </div>
          {/* Delete Button */}
          <div style={{ marginTop: "10px" }}>
            <button
              onClick={() => handleDeleteUser(user.userId)}
              disabled={isDeleting && currentDeletingId === user.userId}
              style={{
                backgroundColor: "#ff4444",
                color: "white",
                padding: "8px 16px",
                borderRadius: "4px",
                border: "none",
                cursor:
                  isDeleting && currentDeletingId === user.userId
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  isDeleting && currentDeletingId === user.userId ? 0.7 : 1,
              }}
            >
              {isDeleting && currentDeletingId === user.userId
                ? "삭제 중..."
                : "유저 삭제"}
            </button>
          </div>

          {/* Song Requests */}
          <div>
            <p>노래 요청 목록:</p>
            {user.songRequestList?.length > 0 &&
              user.songRequestList.map((songRequest) => (
                <div
                  style={{ display: "flex", gap: 4 }}
                  key={songRequest.songRequestId}
                >
                  <p>{songRequest.songTitle}</p>
                  <p>{songRequest.artistName}</p>
                </div>
              ))}
          </div>

          {/* User Management Buttons */}
          <div style={{ marginTop: "10px" }}>
            {editingUserId === user.userId ? (
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  placeholder="새 유저 이름 입력"
                  value={newUserName}
                  onChange={(e) => setNewUserName(e.target.value)}
                />
                <button
                  onClick={() => {
                    handleChangeUserInfo({ userId: user.userId, newUserName });
                    setEditingUserId(null);
                    setNewUserName("");
                  }}
                >
                  확인
                </button>
                <button onClick={() => setEditingUserId(null)}>취소</button>
              </div>
            ) : (
              <button onClick={() => setEditingUserId(user.userId)}>
                이름 바꾸기
              </button>
            )}
          </div>
        </div>
      ))}
    </>
  );
}

export default UserPage;
